import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { AppServiceManager } from 'common/services/appServiceManager';
import { ActivatedRoute } from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { AuthService } from 'common/services/auth.service';
import { IRequest } from 'app/shared/Domains/request';
import { IUser } from 'app/shared/Domains/IUser';
import { Configuration } from 'config/config';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IBranch } from 'app/shared/Domains/branch';
@Component({
  selector: 'app-feesApproval',
  templateUrl: './feesApproval.component.html',
  styleUrls: ['./feesApproval.component.css']
})
export class FeesApprovalComponent implements OnInit {

  requests: IRequest[] = [];
  soureRequstors: IRequest[] = [];
  userRole: IUser;
  searchValue: any;
  loading: boolean = false;
  overAllTotal: Number = 0;
  statusOptions: any[] = [];
  statusOptionValue: any = 'Pending'
  filteredRequests: IRequest[];
  requestTypeOptions: any[] = [];
  requestTypeOptionValue: any = 'All'
  branch: IBranch;
  customerFees: any[];
  tableData: any[] = [
    { column1: 'Fee Submission', Pending: '', Approved: '', Rejected: '', Total: '' },
    { column1: 'Registration', Pending: '', Approved: '', Rejected: '', Total: '' },
    { column1: 'Visitor', Pending: '', Approved: '', Rejected: '', Total: '' },
    { column1: 'OnlineRegistrationFee', Pending: '', Approved: '', Rejected: '', Total: '' },
  ];
  user: any;

  constructor(private LanguageService: LanguageService, private route: ActivatedRoute, public config: Configuration, private ConfirmationService: ConfirmationService, private messageService: MessageService, private breadcrumbService: BreadcrumbService, private appServiceManager: AppServiceManager) {
    this.breadcrumbService.setItems([
      { label: 'Fees Approval' }
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("RequestsManagementComponent", label);
  }
  ngOnInit() {
    this.userRole = AuthService.getLoggedInRole();
    this.user = AuthService.getLoggedInUser();
    this.resetFilter();
    this.getFees();
    this.statusOptions = [{ label: "All", value: 'All' }, { label: "Approved", value: 'Approved' }, { label: "Pending", value: 'Pending' }];
    
  }

  getFees() {
    this.branch = AuthService.getLoggedInCurrentBranch();
    this.loading = true;
        this.appServiceManager
        .get("customerFees/branch/"  + this.branch._id).subscribe(
            (res: any) => {
              if (res.length > 0) {
                this.customerFees = res.reverse();
              } else {
                this.messageService.clear();
                this.messageService.add({
                  severity: "info",
                  summary: "Info Message",
                  detail: "No Record Found",
                });
              }
              this.loading = false;
            },
            (error) => {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: error.error.message,
              });
            }
          );
  }



  filterRequests() {
    if (this.statusOptionValue === 'All') {
      this.filteredRequests = this.requests;
    } else {
      this.filteredRequests = this.requests.filter(request => request.requestStatus === this.statusOptionValue);
    }
  }
  filterRequestsType() {
    if (this.requestTypeOptionValue === 'All') {
      this.filteredRequests = this.requests;
    } else {
      this.filteredRequests = this.requests.filter(request => request.requestType === this.requestTypeOptionValue);
    }
  }

  resetFilter() {
    this.searchValue = '';
    this.statusOptionValue = 'All';
    this.requestTypeOptionValue = 'All';
    this.requests = [];
    this.getFees();
  }

  searchLocal(value) {
    let matchedRequest = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.requests = Object.assign([], this.soureRequstors);
      }
      if (!value) {
        this.requests = Object.assign([], this.soureRequstors);
      }
      if (value != "") {
        matchedRequest = Object.assign([], this.soureRequstors).filter(
          requestor => requestor.name ? requestor.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        // const source = matchedPackage.concat(matchedPackage);
        this.requests = matchedRequest.filter(distinct);

        if (this.requests.length === 0) {
          this.requests = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {

          this.requests = [...this.requests];
        }
      }
    } else {
      this.requests = Object.assign([], this.soureRequstors);
      this.requests = [...this.requests];
    }
  }


  feesApproval(fees) {
    this.ConfirmationService.confirm({
      message: "Are you sure you want to approve fees ?",
      accept: () => {
        this.loading = true;

        this.appServiceManager
            .post("customerFees/approveFee", fees)
            .subscribe(
                (response: any) => {
                    this.loading = false;
                    this.getFees();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Fee Successfully Approved",
                    });
                },
                (error) => {
                    this.loading = false;
                }
            );
    },
    })
  }
}
